const inventory = (state = [], action) => {
    let typeIndex
    let inventory
    let articleEntries
    switch (action.type) {
        case 'GET_INVENTORY':
            return [
                ...state,
            ]
        case 'ADD_ARTICLETYPE':
            console.log("ADD_ARTICLETYPE, State: ")
            console.log(state.inventory)
            typeIndex = [...state].findIndex(x => x.articleType == action.sizeCat)
            inventory = [...state]
            console.log(typeIndex)
            console.log(inventory)
            articleEntries = [...inventory[typeIndex].articleEntries]
            articleEntries = [
                ...articleEntries,
                {
                    articleEntry: action.name,
                    articleImage: action.image,
                    price: action.price,
                    style: action.style,
                    gender: action.gender,
                    articleNumber: action.articleNumber,
                    sizeEntries: action.sizeEntries
                }
            ]
            inventory[typeIndex] = {
                ...inventory[typeIndex],
                articleEntries: articleEntries
            }

            return [
                ...inventory
            ]
        case 'UPDATE_ARTICLETYPE':
            typeIndex = [...state].findIndex(x => x.articleType == action.sizeCat)
            inventory = [...state]
            articleEntries = [...inventory[typeIndex].articleEntries]

            console.log("ACTION.NAME")
            console.log(action.name)
            let articleEntryIndex = articleEntries.findIndex(x => x.articleEntry == action.name)
            articleEntries[articleEntryIndex] = {
                ...articleEntries[articleEntryIndex],
                articleEntry: action.name,
                price: action.price,
                style: action.style,
                gender: action.gender,
                articleNumber: action.articleNumber,
            }
            inventory[typeIndex] = {
                ...inventory[typeIndex],
                articleEntries: articleEntries
            }
            return [
                ...inventory
            ]
        /////////////////////////////////////////
        case 'DUMMY_ADD_TO_STOCK':
            let stock = [...state]
            let entry = [...state].find(x => x.articleType == action.addStock.articleType)
            let entryIndex = [...state].findIndex(x => x.articleType == action.addStock.articleType)
            console.log('DUMMY_ADD_TO_STOCK')
            console.log(action)
            console.log(action.addStock.articleType)
            
            if (entry == null || entry == undefined) {
                return [
                    ...state,
                    {
                        articleType: action.addStock.articleType,
                        articleEntries: action.addStock.articleEntries
                    }
                ]
            }
            else {
                //Case: ArticleType, ArticleEntries, SizeEntries already existant: only increase Numbers in inventory
                //for every acrticleEntry -> for every sizeEntry -> 

                action.addStock.articleEntries.forEach(x => x.sizeEntries.forEach(y => stock[entryIndex].articleEntries.find(a => a.articleEntry == x.articleEntry).sizeEntries.find(b => b.sizeEntry == y.size).amount += parseInt(y.number)))

                return stock
            }

        case 'DUMMY_REMOVE_FROM_STOCK':
            let stock2 = [...state]
            let entry2 = [...state].find(x => x.articleType == action.addStock.articleType)
            let entryIndex2 = [...state].findIndex(x => x.articleType == action.addStock.articleType)
            if (entry2 == null || entry2 == undefined) {
                return [
                    ...state
                ]
            }
            else {
                //Case: ArticleType, ArticleEntries, SizeEntries already existant: only increase Numbers in inventory
                //for every acrticleEntry -> for every sizeEntry -> 

                action.addStock.articleEntries.forEach(x => x.sizeEntries.forEach(y => stock2[entryIndex2].articleEntries.find(a => a.articleEntry == x.articleEntry).sizeEntries.find(b => b.sizeEntry == y.size).amount -= parseInt(y.number)))

                return stock2
            }
        ////////////////////////////////////////
        default:
            return state
    }
}
export { inventory }